
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IntegrationInfo',

  props: {
    description: {
      type: String,
      required: true
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'How does it work?'
    }
  },

  emits: ['hide-integration-info']
})
